import { useState } from "react";
import { useForm, FormProvider, Controller } from "react-hook-form";

// Import inhouse icons
import { Plus, ChevronRight } from "lucide-react";

// Import reusable components
import FormCard from "@/components/formInputFields/FormCard";
import FormInput from "@/components/formInputFields/FormInput";
import FormTextarea from "@/components/formInputFields/FormTextarea";
import FormCheckbox from "@/components/formInputFields/FormCheckbox";
import FormSectionTitle from "@/components/formInputFields/FormSectionTitle";
import { Button } from "@/components/ui/button";
import CustomerAddressModal from "./CustomerAddressModal";
import FormPhoneInput from "@/components/formInputFields/FormPhoneInput";
import CustomerOverviewSection from "./CustomerOverviewSection";
import CustomerNotesSection from "./CustomerNotesSection";
import CustomerAddressSection from "./CustomerAddressSection";

const countryOptions = [
  { value: "kenya", label: "Kenya" },
  { value: "united-states", label: "United States" },
  { value: "united-kingdom", label: "United Kingdom" },
  { value: "canada", label: "Canada" },
];

export default function CustomerPageForm({ customerId = null }) {
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);

  // TODO: hook customerId into data loading once backend wiring lands
  void customerId;

  const form = useForm({
    defaultValues: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      marketingEmailOptIn: false,
      marketingSmsOptIn: false,
      notes: "",
      defaultAddress: {
        country: "",
        firstName: "",
        lastName: "",
        company: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        postalCode: "",
        phone: "",
      },
    },
  });

  const {
    register,
    control,
    formState: { errors },
  } = form;

  return (
    <FormProvider {...form}>
      <form
        onSubmit={form.handleSubmit(() => {})}
        className="flex flex-col gap-[1em] mb-[4em]"
      >
        <div className="flex gap-[1em]">
          {/* Customer overview section */}
          <CustomerOverviewSection />

          {/* Notes section */}
          <CustomerNotesSection />
        </div>

        {/* Primary address section */}
        <CustomerAddressSection />
      </form>
    </FormProvider>
  );
};